(function () {
    'use strict';

    angular
        .module('franchisee-portal.filters')
        .filter('momentTimeNow', momentTimeNow)

    function momentTimeNow() {
        function momentTimeNowFn(value) {
            moment.locale('pt-br');

            var dateValue;

            if (!value)
                return '';

            dateValue = moment(value);

            if (!dateValue.isValid())
                return '';

            return moment().to(dateValue);
        }

        return momentTimeNowFn;
    }
}());